import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SMSTextService } from 'src/app/Service/SMSText/SMSText.service';

@Component({
  selector: 'app-SMSTextList',
  templateUrl: './SMSTextList.component.html',
  styleUrls: ['./SMSTextList.component.scss']
})
export class SMSTextListComponent implements OnInit {
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private SMSText_Service:SMSTextService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_SMSText:Array<General_Interface>=[]
  Data_Seleted_Delete:General_Interface=Empty_General_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(40).subscribe(
      data=>{
        this.ReadData_SMSText()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_SMSText(){
    this.Procssing=true
    this.SMSText_Service.GetRecord().subscribe(
      data=>{
        this.DataList_SMSText=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:General_Interface){
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.SMSText_Service.DeleteSMS_Text(item.id).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("حذف شد")
        this.ReadData_SMSText()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

}
